/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { elementInViewport, getWindowSize, scrollTo } from '../../utils/dom.mjs';
import '../../_chunks/dep-a48de419.mjs';
import '../../_chunks/dep-2684fd15.mjs';
import '../../_chunks/dep-3ca5fb38.mjs';
import '../../_chunks/dep-7071345f.mjs';
import '../../_chunks/dep-3d4aad09.mjs';
import '../../_chunks/dep-c27b1c14.mjs';
import '../../utils/easing.mjs';

function scrollToElm(elm) {
  var rect = elm.getBoundingClientRect();

  if (!elementInViewport(elm)) {
    var winHeight = getWindowSize().height;
    var top = rect.bottom - (rect.bottom - rect.top);
    scrollTo(rect.top - (winHeight / 2 - rect.height / 2), {});
  }
}

export { scrollToElm as default };
//# sourceMappingURL=scrollToElm.mjs.map
